import React, { useState } from 'react'
import { ChatState } from '../Context/ChatProvider'
import { Box, Flex, calc } from '@chakra-ui/react'
import SideDrawer from '../components/UIComponents/SideDrawer'
import MyChats from '../components/UIComponents/MyChats'
import ChatBox from '../components/UIComponents/ChatBox'
import { Navigate } from 'react-router-dom'

const Chat = () => {
  const  {user} =   ChatState()
  const [fetchAgain,setFetchAgain] = useState(false)
  
  return (
    <Box w='100%' maxH={'100vh'}>
      { user && <SideDrawer/>}
      <Flex justifyContent={'space-between'} w='100%'h={{base:'calc(100vh - 50px)',md:'calc(100vh - 50px)'}} p={{md:'10px'}} >
      {user && <MyChats fetchAgain={fetchAgain}/>}
      {user && <ChatBox  fetchAgain={fetchAgain} setFetchAgain={setFetchAgain}/>}
      </Flex>
    </Box>
  )
}

export default Chat